import axios from "axios";

// ACTION TYPES
const SET_PROPERTIES = "SET_PROPERTIES";
const SET_PROPERTY = "SET_PROPERTY";
const UPDATE_PROPERTY = "UPDATE_PROPERTY";
const ADD_PROPERTY = "ADD_PROPERTY";
const DELETE_PROPERTY = "DELETE_PROPERTY";

// ACTION CREATORS
const setProperties = (properties) => ({
  type: SET_PROPERTIES,
  properties,
});

const setProperty = (property) => ({
  type: SET_PROPERTY,
  property,
});

const updatePropertyInfo = (property) => ({
  type: UPDATE_PROPERTY,
  property,
});

const addNewProperty = (property) => ({
  type: ADD_PROPERTY,
  property,
});

const deleteSingleProperty = (property) => ({
  type: DELETE_PROPERTY,
  property,
});

// THUNK CREATORS
export const getProperties = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get("/api/properties/");
      dispatch(setProperties(data));
    } catch (error) {
      console.log("Error fetching properties from the server:", error);
    }
  };
};

export const getProperty = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(`/api/properties/${id}`);
      dispatch(setProperty(data));
    } catch (error) {
      console.log("Error fetching properties from the server:", error);
    }
  };
};

export const updateProperty = (id, info) => {
  return async (dispatch) => {
    try {
      console.log("id:", id, "  info:", info);
      const { data } = await axios.put(`/api/properties/${id}`, info);
      console.log("DATA:", data);
      dispatch(updatePropertyInfo(data));
    } catch (error) {
      console.log(`Error updating property ${id}:`, error);
    }
  };
};

export const addProperty = (property) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.post("/api/properties/", property);
      dispatch(addNewProperty(data));
    } catch (error) {
      console.log("Error adding property:", error);
    }
  };
};

export const deleteProperty = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.delete(`/api/properties/${id}`);
      dispatch(deleteSingleProperty(data));
    } catch (error) {
      console.log(`Error deleting property ${id}:`, error);
    }
  };
};

const initialState = { single: {}, all: [] };

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_PROPERTIES:
      return { ...state, all: action.properties };
    case SET_PROPERTY:
      return { ...state, single: action.property };
    case UPDATE_PROPERTY:
      const newArr = state.all.map((property) => {
        if (property.id == action.property.id) {
          return action.property;
        }
        return property;
      });
      return { all: newArr, single: action.property };
    case ADD_PROPERTY:
      return { ...state, all: [...state.all, action.property] };
    case DELETE_PROPERTY:
      const updatedArr = state.all.filter((property) => {
        if (property.id !== action.property.id) {
          return property;
        }
      });
      return { ...state, all: updatedArr };
    default:
      return state;
  }
}
